<template>
    <div v-if="componentData" class="wrapper Video">
        <a :href="componentData.videoLink" data-fancybox="video-gallery">
            <SafeImage 
                :imageData="componentData.image"
                :alt="componentData.image.data.attributes.alternativeText"
                :placeholder="PLACEHOLDER_IMAGES.GENERAL"
                placeholderText="Video image not available"
            />
            <span class="iconVideo"><play-icon/></span>
        </a>
    </div>
</template>

<script lang="ts">

import { defineComponent } from 'vue'

import { Fancybox } from "@fancyapps/ui/dist/fancybox/fancybox.esm.js";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

import PlayIcon from '../svg/PlayIcon.vue'
import SafeImage from '../SafeImage.vue'
import { PLACEHOLDER_IMAGES } from '../../composables/useImageErrorHandler'

export default defineComponent({
    components:{
        PlayIcon,
        SafeImage
    },
    props:{
        componentData: {
            type: Object,
            required: false
        },
    },
    setup(props) {
        const homeurl: string = import.meta.env.VITE_API_URL;

        Fancybox.bind('[data-fancybox="video-gallery"]', {
            //
        });

        return {
            homeurl,
            PLACEHOLDER_IMAGES
        };
    }
})

</script>

<style scoped>
/* @import '~flickity/dist/flickity.css'; */
</style>
